module.exports = __webpack_public_path__ + "static/media/HCMM346.f69522fb.jpg";